import { useState } from 'react';
import { checkEnvironmentVariables } from '@/utils/envChecker';
import { getSupabaseSafe } from '@/lib/supabase';

export function EnvDebugger() {
  const [isOpen, setIsOpen] = useState(false);
  const [envCheck, setEnvCheck] = useState<any>(null);

  const runCheck = () => {
    const result = checkEnvironmentVariables();
    setEnvCheck(result);
    
    // Also test Supabase client
    try {
      const supabase = getSupabaseSafe();
      console.log('Supabase client test:', supabase ? 'Success' : 'Failed');
    } catch (error) {
      console.error('Supabase client test failed:', error);
    }
  };

  if (!import.meta.env.DEV) {
    return null; // Only show in development
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-orange-500 text-white px-3 py-2 rounded-lg text-sm font-medium shadow-lg hover:bg-orange-600"
      >
        🔧 Env Debug
      </button>
      
      {isOpen && (
        <div className="absolute bottom-12 right-0 bg-white border border-gray-200 rounded-lg shadow-xl p-4 w-80 max-h-96 overflow-y-auto">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-gray-900">Environment Variables</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>
          
          <button
            onClick={runCheck}
            className="w-full bg-blue-500 text-white px-3 py-2 rounded mb-3 text-sm hover:bg-blue-600"
          >
            Check Environment
          </button>
          
          {envCheck && (
            <div className="space-y-2 text-sm">
              <div className="font-medium text-green-600">
                ✅ Present ({envCheck.present.length}):
              </div>
              {envCheck.present.map((key: string) => (
                <div key={key} className="text-xs text-gray-600 ml-2">
                  {key}
                </div>
              ))}
              
              {envCheck.missing.length > 0 && (
                <>
                  <div className="font-medium text-red-600">
                    ❌ Missing ({envCheck.missing.length}):
                  </div>
                  {envCheck.missing.map((key: string) => (
                    <div key={key} className="text-xs text-red-600 ml-2">
                      {key}
                    </div>
                  ))}
                </>
              )}
              
              <div className="mt-3 pt-3 border-t border-gray-200">
                <div className="font-medium text-gray-700">Values:</div>
                <pre className="text-xs text-gray-600 mt-1 bg-gray-50 p-2 rounded overflow-x-auto">
                  {JSON.stringify(envCheck.values, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}